<script setup>
  let props = defineProps({
    delVisible: Boolean,
  })

  let emits = defineEmits(['update:delVisible', 'on-del'])

  const closeFunc = () => {
    emits('update:delVisible', false)
  }

  const delFunc = () => {
    emits('on-del')
    closeFunc()
  }
</script>

<template>
  <a-modal
    :visible="delVisible"
    :footer="null"
    :bodyStyle="{ padding: '0' }"
    title="删除"
    centered
    wrapClassName="del-modal"
    @cancel="closeFunc"
  >
    <div class="padding-30">是否确定删除该记录?</div>
    <div class="del-footer">
      <a-button @click="closeFunc" class="margin-r-10">取消</a-button>
      <a-button type="primary" @click="delFunc">确定</a-button>
    </div>
  </a-modal>
</template>

<style lang="scss" scoped>
  .del-modal {
    .del-footer {
      display: flex;
      justify-content: flex-end;
      height: 56px;
      padding-top: 12px;
      padding-right: 20px;
      background: #fff;
      box-shadow:
        0px 4px 20px 0px rgba(0, 0, 0, 0.1),
        inset 0px 1px 0px 0px #eee;
      border-radius: 0px 0px 8px 8px;
    }
  }
</style>
